import { Card, Text } from "@mantine/core";

interface HeldEmailStatCardProps {
  label: string;
  value: number;
}

export function HeldEmailStatCard({ label, value }: HeldEmailStatCardProps) {
  return (
    <Card withBorder>
      <Text c="dimmed" size="sm">
        {label}
      </Text>
      <Text fw={700} size="xl">
        {value}
      </Text>
    </Card>
  );
}
